module.exports = __webpack_public_path__ + "static/2-2bee0c167e11e487807fc0a074cd336a.jpg";